(function () {
  'use strict';

  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Collection sorting
  var sort = document.querySelector('[data-sort-by]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  var product = document.querySelector('[data-product]');
  if (!product) return;

  // Sent with the order: the order script ignores forms sent a few seconds after the page opened (bots)
  var openedAt = Date.now();

  // Gallery
  function showMedia(id) {
    if (!id) return;
    var target = product.querySelector('[data-media-id="' + id + '"]');
    if (!target) return;
    product.querySelectorAll('[data-media-id]').forEach(function (el) {
      el.classList.toggle('is-active', el === target);
    });
    product.querySelectorAll('[data-thumb]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-thumb') === String(id));
    });
  }

  product.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      showMedia(thumb.getAttribute('data-thumb'));
    });
  });

  // Cash on delivery form
  var cod = product.querySelector('[data-cod]');
  var variantSelect = product.querySelector('[data-variant-select]');
  var qtyInput = product.querySelector('[data-qty-input]');
  var summary = product.querySelector('[data-cod-summary]');
  var wilaya = product.querySelector('[data-cod-wilaya]');
  var lang = cod ? cod.getAttribute('data-lang') : document.documentElement.lang;

  // A non-breaking space keeps "7,900 DZD" in one piece
  var nbsp = String.fromCharCode(160);
  var currency = cod ? cod.getAttribute('data-currency') : 'DZD';
  var sep = cod ? cod.getAttribute('data-sep') : ',';
  if (sep === ' ') sep = nbsp;

  function formatAmount(amount) {
    var units = String(Math.round(amount));
    var out = '';
    while (units.length > 3) {
      out = sep + units.slice(-3) + out;
      units = units.slice(0, -3);
    }
    return units + out + nbsp + currency;
  }

  // Texts come from the form so they follow the language of the page
  function label(name, fallback) {
    return (cod && cod.getAttribute('data-' + name)) || fallback;
  }

  function number(name) {
    return cod ? parseFloat(cod.getAttribute('data-' + name)) || 0 : 0;
  }

  // "2, 6, 9" -> { 2: true, 6: true, 9: true }
  function parseCodes(text) {
    var codes = {};
    (text || '').split(/[^0-9]+/).forEach(function (part) {
      var code = parseInt(part, 10);
      if (!isNaN(code)) codes[code] = true;
    });
    return codes;
  }

  var shippingEnabled = cod && cod.getAttribute('data-shipping-enabled') === 'true';
  var freeAbove = number('free-above');
  var zone1 = parseCodes(cod ? cod.getAttribute('data-zone1') : '');
  var zone2 = parseCodes(cod ? cod.getAttribute('data-zone2') : '');
  var zone1Fee = number('zone1-fee');
  var zone2Fee = number('zone2-fee');
  var defaultFee = number('shipping-default');

  function selectedOption() {
    return variantSelect ? variantSelect.options[variantSelect.selectedIndex] : null;
  }

  function unitPrice() {
    var option = selectedOption();
    var cents = option ? option.getAttribute('data-price') : summary ? summary.getAttribute('data-price') : 0;
    return (parseInt(cents, 10) || 0) / 100;
  }

  function quantity() {
    var value = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return value > 0 ? value : 1;
  }

  function shippingFee() {
    if (!shippingEnabled || !wilaya || !wilaya.value) return null;
    if (freeAbove > 0 && unitPrice() * quantity() >= freeAbove) return 0;
    var code = parseInt(wilaya.options[wilaya.selectedIndex].getAttribute('data-code'), 10);
    if (zone1[code]) return zone1Fee;
    if (zone2[code]) return zone2Fee;
    return defaultFee;
  }

  function setText(selector, value) {
    var el = cod.querySelector(selector);
    if (el) el.textContent = value;
  }

  function updateSummary() {
    if (!cod || !summary) return;
    var subtotal = unitPrice() * quantity();
    var fee = shippingFee();
    setText('[data-cod-subtotal]', formatAmount(subtotal));
    setText('[data-cod-total]', formatAmount(subtotal + (fee || 0)));
    if (shippingEnabled) {
      setText('[data-cod-shipping]', fee === null ? label('text-wilaya', 'Select your wilaya') : fee === 0 ? label('text-free', 'Free') : formatAmount(fee));
    }
    updateWhatsApp();
  }

  // "Order via WhatsApp" message follows the chosen size, colour and quantity
  var waLink = product.querySelector('[data-wa-order]');
  function updateWhatsApp() {
    if (!waLink || !cod) return;
    var option = selectedOption();
    var text =
      waLink.getAttribute('data-wa-text') +
      ' ' +
      cod.getAttribute('data-product') +
      (option ? ' (' + option.getAttribute('data-title') + ')' : '') +
      ' x' +
      quantity() +
      ' — ' +
      waLink.getAttribute('data-wa-url');
    waLink.href = 'https://wa.me/' + waLink.getAttribute('data-wa-number') + '?text=' + encodeURIComponent(text);
  }

  function updateVariant() {
    var option = selectedOption();
    if (!option) return;
    product.querySelectorAll('[data-price-current]').forEach(function (el) {
      el.textContent = option.getAttribute('data-price-money');
    });
    var compare = product.querySelector('[data-price-compare]');
    if (compare) {
      var compareMoney = option.getAttribute('data-compare-money');
      compare.textContent = compareMoney || '';
      compare.hidden = !compareMoney;
    }
    showMedia(option.getAttribute('data-media'));
    updateSummary();
  }

  if (variantSelect) variantSelect.addEventListener('change', updateVariant);
  if (wilaya) wilaya.addEventListener('change', updateSummary);

  // Option buttons (colour, size): pick the matching variant in the hidden select
  var optionGroups = product.querySelectorAll('[data-option]');
  var submitButton = cod ? cod.querySelector('[data-cod-submit]') : null;
  if (variantSelect && optionGroups.length) {
    var variantField = product.querySelector('[data-variant-field]');
    var unavailable = product.querySelector('[data-option-unavailable]');
    if (variantField) variantField.hidden = true;
    optionGroups.forEach(function (group) {
      group.hidden = false;
    });

    var syncVariant = function () {
      var chosen = [];
      optionGroups.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var selected = group.querySelector('[data-option-selected]');
        chosen.push(checked ? checked.value : '');
        if (selected && checked) selected.textContent = checked.getAttribute('data-label') || checked.value;
      });
      var match = null;
      Array.prototype.forEach.call(variantSelect.options, function (option) {
        var same = chosen.every(function (value, index) {
          return option.getAttribute('data-option' + (index + 1)) === value;
        });
        if (same) match = option;
      });
      var available = !!match && !match.disabled;
      if (match) {
        variantSelect.value = match.value;
        updateVariant();
      }
      if (unavailable) unavailable.hidden = available;
      if (submitButton) submitButton.disabled = !available;
    };

    optionGroups.forEach(function (group) {
      group.addEventListener('change', syncVariant);
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener('input', updateSummary);
    var minus = product.querySelector('[data-qty-minus]');
    var plus = product.querySelector('[data-qty-plus]');
    if (minus) {
      minus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, quantity() - 1);
        updateSummary();
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        qtyInput.value = Math.min(parseInt(qtyInput.max, 10) || 20, quantity() + 1);
        updateSummary();
      });
    }
  }

  // Phone: accept what customers type (spaces, dots, Arabic digits, 00213 / +213 prefixes)
  // and turn it into 0XXXXXXXXX so it passes validation and the order script
  var normalizePhone = function (value) {
    return value
      .replace(/[٠-٩۰-۹]/g, function (d) {
        var code = d.charCodeAt(0);
        return String(code - (code >= 0x06f0 ? 0x06f0 : 0x0660));
      })
      .replace(/[\s.\-()]/g, '')
      .replace(/^(?:\+|00)?2130?(?=[5-7][0-9]{8}$)/, '0');
  };
  var phone = product.querySelector('[data-cod-phone]');
  if (phone) {
    phone.addEventListener('input', function () {
      phone.setCustomValidity('');
    });
    phone.addEventListener('blur', function () {
      phone.value = normalizePhone(phone.value);
    });
    // The browser's own message ("Please match the requested format") does not say what is expected
    phone.addEventListener('invalid', function () {
      if (phone.validity.patternMismatch) {
        phone.setCustomValidity(label('error-phone', 'Invalid number: 10 digits starting with 05, 06 or 07.'));
      }
    });
  }

  var form = cod ? cod.querySelector('form') : null;
  if (form) {
    var endpoint = cod.getAttribute('data-endpoint');
    var errorBox = cod.querySelector('[data-cod-error]');
    var buttonLabel = submitButton ? submitButton.textContent : '';

    // Coming back from the checkout with the back button: make the button usable again
    window.addEventListener('pageshow', function () {
      if (submitButton && submitButton.textContent !== buttonLabel) {
        submitButton.disabled = false;
        submitButton.textContent = buttonLabel;
      }
    });

    var field = function (name) {
      var el = form.querySelector('[data-cod-field="' + name + '"]');
      return el ? el.value.trim() : '';
    };

    var variantId = function () {
      var option = selectedOption();
      return option ? option.getAttribute('data-id') : cod.getAttribute('data-variant-id');
    };

    // Without an order script: the Shopify checkout with the cart and the details already filled in
    var goToCheckout = function () {
      var phoneNumber = field('telephone').replace(/^0/, '+213');
      var wilayaName = wilaya.value.replace(/^[0-9]{2} - /, '');
      var params = new URLSearchParams();
      params.set('checkout[shipping_address][first_name]', field('prenom'));
      params.set('checkout[shipping_address][last_name]', field('nom'));
      params.set('checkout[shipping_address][phone]', phoneNumber);
      params.set('checkout[shipping_address][address1]', field('commune') + ', ' + wilayaName);
      params.set('checkout[shipping_address][city]', field('commune'));
      params.set('checkout[shipping_address][country]', 'DZ');
      params.set('attributes[Wilaya]', wilaya.value);
      params.set('attributes[Commune]', field('commune'));
      params.set('attributes[Téléphone]', phoneNumber);
      var root = cod.getAttribute('data-root') || '/';
      window.location.href = root + 'cart/' + variantId() + ':' + quantity() + '?' + params.toString();
    };

    var showSuccess = function (orderName) {
      var template = cod.querySelector('[data-cod-success-template]');
      form.innerHTML = '';
      form.appendChild(template.content.cloneNode(true));
      var id = form.querySelector('[data-cod-order-name]');
      if (id && orderName) {
        id.textContent = orderName;
        id.hidden = false;
      }
      if (waLink) waLink.hidden = true;
      cod.scrollIntoView({ block: 'center' });
    };

    // The order script answers in French: on the English and Arabic pages, show the page's own message
    var serverMessage = function (message) {
      if (!message) return '';
      if (lang === 'fr') return message;
      if (message.indexOf('déjà') !== -1) return label('error-duplicate', message);
      if (message.indexOf('téléphone') !== -1) return label('error-phone', message);
      if (message.indexOf('prénom') !== -1) return label('error-name', message);
      return '';
    };

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (phone) phone.value = normalizePhone(phone.value);
      // A name made only of spaces passes "required": trim first so it is caught
      form.querySelectorAll('[data-cod-field="nom"], [data-cod-field="prenom"], [data-cod-field="commune"]').forEach(function (input) {
        input.value = input.value.trim();
      });
      updateSummary();
      // Never fall through to the native submit (it would add to the cart instead of ordering)
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var trap = form.querySelector('[data-cod-trap]');
      if (trap && trap.value) return showSuccess();

      submitButton.disabled = true;
      submitButton.textContent = cod.getAttribute('data-sending') || buttonLabel;
      if (errorBox) errorBox.hidden = true;

      if (!endpoint) return goToCheckout();

      var payload = {
        nom: field('nom'),
        prenom: field('prenom'),
        telephone: field('telephone'),
        wilaya: wilaya ? wilaya.value : '',
        commune: field('commune'),
        variantId: variantId(),
        quantity: quantity(),
        shipping: shippingFee(),
        langue: lang,
        page: window.location.href,
        elapsed: Date.now() - openedAt
      };

      var showError = function (message) {
        submitButton.disabled = false;
        submitButton.textContent = buttonLabel;
        if (errorBox) {
          errorBox.textContent = message || label('error-generic', 'Your order could not be sent. Please try again.');
          errorBox.hidden = false;
          errorBox.scrollIntoView({ block: 'center' });
        }
      };

      // Meta pixel (loaded by the Facebook & Instagram app): these orders skip the Shopify checkout,
      // so the app never reports them. Describe the product the way the app does (product id, product_group).
      var trackPurchase = function (orderName) {
        if (typeof window.fbq !== 'function') return;
        var productId = parseInt(cod.getAttribute('data-product-id'), 10);
        window.fbq(
          'track',
          'Purchase',
          {
            content_ids: productId ? [productId] : [],
            content_type: 'product_group',
            contents: [{ id: productId, quantity: payload.quantity, item_price: unitPrice() }],
            num_items: payload.quantity,
            value: unitPrice() * payload.quantity,
            currency: 'DZD'
          },
          { eventID: 'frvme-order-' + String(orderName).replace(/\D/g, '') }
        );
      };

      // Sent as text/plain so the browser does not need a CORS preflight
      fetch(endpoint, { method: 'POST', body: JSON.stringify(payload) })
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          if (result && result.ok) {
            // No order name means the script ignored the form (bot): nothing to report
            if (result.order) trackPurchase(result.order);
            return showSuccess(result.order);
          }
          showError(serverMessage(result && result.message));
        })
        .catch(function () {
          showError(label('error-network', 'No connection. Check your network and try again.'));
        });
    });
  }

  updateSummary();

  // Sticky order button: visible on mobile while the form is off screen
  var sticky = product.querySelector('[data-sticky-cta]');
  if (sticky && cod && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }).observe(cod);
  }
})();
